import Vue from 'vue'
import VueRouter from 'vue-router'
import VueI18n from 'vue-i18n'
import { sync } from 'vuex-router-sync'
import store from './vuex/store'
import router from './router'
import VueHead from 'vue-head'
import axios from 'axios'
import cookies from 'utilities/cookies'
import hmacSHA512 from 'crypto-js/hmac-sha512'
import Hex from 'crypto-js/enc-hex'
import gaExt from 'utilities/gaExt'
import VueDfp from 'utilities/vue-dfp'
import jsonLd from 'utilities/json-ld'
import VueSwal from 'utilities/vue-sweetalert2'
import configLocales from 'utilities/locales'
import App from './app.vue'

Vue.use(VueRouter)
Vue.use(VueI18n)
Vue.use(VueSwal)
Vue.use(VueHead)
Vue.use(VueDfp, { dfpID: '111212456', setCentering: true })
Vue.directive('json-ld', jsonLd)

const i18n = new VueI18n({
  locale: 'tw',
  fallbackLocale: 'tw',
  messages: configLocales
})

Vue.config.devtools = process.env.NODE_ENV === 'development'
Vue.config.silent = process.env.NODE_ENV !== 'development'

if ('amplitude' in window) {
  window.amplitude.getInstance().init(process.env.AMPLITUDE, null, {
    saveEvents: true,
    includeUtm: true,
    includeReferrer: true
  })
}

router.beforeEach((to, from, next) => {
  const path = '/' + to.path.split('/').reduce((a, p) => {
    if (p.trim() !== '') {
      a = a.concat([p])
    }
    return a
  }, []).join('/')
  if (to.path !== path) {
    window.location.href = path
  } else {
    // Auto detect locale from URL.
    const locale = to.path.match(/(tw|en|jp|th)\/(.*)/i)

    if (to.meta.auth === true) {
      if (to.meta.userType === 'manipulator') {
        if (typeof store.getters['manipulators/getToken'] === 'undefined' ||
          store.getters['manipulators/getToken'] === ''
        ) {
          next({ name: 'companySignup' })
        }
      } else {
        if (typeof store.getters['users/getToken'] === 'undefined' ||
          store.getters['users/getToken'] === ''
        ) {
          next({ name: 'signup' })
        }
      }
    }

    if (Array.isArray(locale) && typeof locale[1] !== 'undefined') {
      // Vue.config.lang = locale[1]
      // Vue.config.lang = ''
    }
    next()
  }
})

router.afterEach((to, from) => {
  if (to.meta.auth === true) {
    if (to.meta.userType === 'manipulator') {
      if (typeof store.getters['manipulators/getToken'] === 'undefined' ||
        store.getters['manipulators/getToken'] === ''
      ) {
        router.replace({ name: 'companySignup' })
      }
    } else {
      if (typeof store.getters['users/getToken'] === 'undefined' ||
        store.getters['users/getToken'] === ''
      ) {
        router.replace({ name: 'signup' })
      }
    }
  }

  // Send GA
  Vue.nextTick(() => {
    gaExt.doPageViewBeacon({
      page: to.fullPath
    })
  })
})

sync(store, router)

axios.defaults.xsrfCookieName = 'DEBUT-XSRF-TOKEN'
axios.defaults.xsrfHeaderName = 'X-DEBUT-XSRF-TOKEN'
axios.interceptors.request.use(config => {
  const xsrfToken = Hex.stringify(hmacSHA512(config.url + Date.now(), process.env.GA))
  cookies.set(config.xsrfCookieName, xsrfToken, { expires: 30 })
  config.headers[config.xsrfHeaderName] = xsrfToken
  return config
}, err => {
  cookies.remove(axios.defaults.xsrfCookieName)
  return Promise.reject(err)
})
axios.interceptors.response.use(response => {
  cookies.remove(axios.defaults.xsrfCookieName)
  return Promise.resolve(response)
}, error => {
  cookies.remove(error.config.xsrfCookieName)
  return Promise.reject(error.response)
})

/* eslint-disable no-new */
new Vue({
  store: store,
  router: router,
  i18n: i18n,
  render: h => h(App)
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/app.js